var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _path, _circle9, _rect7, _rect8, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWalletLightSidevar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 209,
    height: 177,
    viewBox: "0 0 209 177",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.05,
    cx: 107.312,
    cy: 88.5,
    r: 87.63,
    fill: "#00A3A4"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 193.067,
    cy: 13.0538,
    r: 4.6861,
    fill: "#00A3A4"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 4.6861,
    cy: 156.448,
    r: 4.6861,
    fill: "#00A3A4"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 183.227,
    cy: 150.357,
    r: 2.34305,
    fill: "#00A3A4"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 206.657,
    cy: 142.859,
    r: 2.34305,
    fill: "#00A3A4"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 197.284,
    cy: 41.639,
    r: 2.34305,
    fill: "#00A3A4"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 13.5898,
    cy: 137.235,
    r: 9.84081,
    fill: "#00A3A4"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 37.957,
    cy: 13.5224,
    r: 9.84081,
    fill: "#00A3A4"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 66.2103,
    y: 59.7124,
    width: 35.3887,
    height: 35.3887,
    transform: "rotate(-11.1471 66.2103 59.7124)",
    fill: "#9FECED",
    stroke: "#00A3A4"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 69.6986,
    y: 62.0525,
    width: 29.4477,
    height: 29.4477,
    transform: "rotate(-11.1471 69.6986 62.0525)",
    fill: "white",
    stroke: "#00A3A4"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 115.397,
    y: 62.4463,
    width: 35.3887,
    height: 35.3887,
    transform: "rotate(29.326 115.397 62.4463)",
    fill: "#9FECED",
    stroke: "#00A3A4"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 116.532,
    y: 66.4909,
    width: 29.4477,
    height: 29.4477,
    transform: "rotate(29.326 116.532 66.4909)",
    fill: "white",
    stroke: "#00A3A4"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 62.9805,
    y: 85.2869,
    width: 85.1448,
    height: 59.1528,
    rx: 4.5,
    fill: "#A2DFDF",
    stroke: "#00A3A4"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 119.42,
    y: 106.823,
    width: 33.1609,
    height: 16.8231,
    rx: 5.5,
    fill: "white",
    stroke: "#00A3A4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M130.301 115.235C130.301 116.599 129.195 117.705 127.831 117.705C126.466 117.705 125.36 116.599 125.36 115.235C125.36 113.87 126.466 112.764 127.831 112.764C129.195 112.764 130.301 113.87 130.301 115.235Z",
    stroke: "#00A3A4"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 130.802,
    cy: 39.4866,
    r: 11.1394,
    fill: "#FAC23D"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 56.5391,
    y: 146.425,
    width: 102.483,
    height: 0.742628,
    fill: "#00A3A4"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 56.5391,
    y: 147.168,
    width: 102.483,
    height: 0.742628,
    fill: "#D7E8EC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M135.254 40.1493H131.211C131.59 39.857 132.057 39.5794 132.437 39.3017C132.524 39.214 132.627 39.214 132.714 39.1117H135.24C135.414 39.1117 135.581 39.0425 135.704 38.9191C135.827 38.7958 135.897 38.6286 135.897 38.4542C135.897 38.2798 135.827 38.1125 135.704 37.9892C135.581 37.8658 135.414 37.7966 135.24 37.7966H133.926C134.139 37.5169 134.297 37.1996 134.393 36.8613C134.542 36.4241 134.585 35.9577 134.519 35.5005C134.453 35.0433 134.28 34.6082 134.013 34.231C132.787 32.3605 130.189 32.4482 128.408 33.3835C127.648 33.7634 128.305 34.8448 129.065 34.5087C129.916 34.0139 130.93 33.8773 131.882 34.1287C132.211 34.2334 132.506 34.4239 132.737 34.6808C132.968 34.9377 133.126 35.2515 133.196 35.59C133.217 35.9708 133.143 36.351 132.98 36.6956C132.817 37.0403 132.57 37.3384 132.262 37.5628H127.181C127.007 37.5628 126.84 37.632 126.717 37.7554C126.594 37.8787 126.524 38.046 126.524 38.2204C126.524 38.3948 126.594 38.562 126.717 38.6853C126.84 38.8087 127.007 38.8779 127.181 38.8779H130.554C130.253 39.1049 129.97 39.354 129.707 39.6232C129.619 39.7255 129.429 39.8132 129.342 40.0031H127.181C127.007 40.0031 126.84 40.0724 126.717 40.1957C126.594 40.3191 126.524 40.4863 126.524 40.6607C126.524 40.8351 126.594 41.0024 126.717 41.1257C126.84 41.249 127.007 41.3183 127.181 41.3183H128.495C128.253 41.9133 128.186 42.5654 128.302 43.1974C128.419 43.8293 128.714 44.4146 129.152 44.8839C130.466 46.3452 132.714 45.9214 134.305 45.1615C135.05 44.7816 134.393 43.7002 133.648 44.0363C132.422 44.6062 130.276 44.9715 129.707 43.2911C129.596 42.9677 129.556 42.6244 129.588 42.2841C129.621 41.9439 129.726 41.6146 129.897 41.3183H135.152C135.239 41.3203 135.325 41.3047 135.406 41.2723C135.486 41.24 135.56 41.1916 135.621 41.1301C135.682 41.0687 135.731 40.9954 135.763 40.9147C135.795 40.834 135.811 40.7476 135.809 40.6607C135.911 40.4269 135.619 40.1493 135.254 40.1493Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletLightSidevar);
export default __webpack_public_path__ + "static/media/WalletLightSidevar.0c3f1e8e9cb5448d5a437f44c3d4f4cb.svg";
export { ForwardRef as ReactComponent };